import APIError from '../errors/APIError';
import { IDeliveryFee } from '../models/DeliveryFee';

import HttpClient from './utils/HttpClient';

type CommonDeliveryFeeResponse = Pick<
  IDeliveryFee,
  | 'id'
  | 'description'
  | 'value'
  | 'distance'
  | 'estimatedTimeInMinutes'
  | 'active'
>;

type ListDeliveryFeesResponse = {
  deliveryFees: CommonDeliveryFeeResponse[];
  suggestions: {
    [neighborhood: string]: {
      lat: number;
      lon: number;
    }[];
  };
};

class DeliveryFeesService {
  private httpClient = HttpClient;

  public async listDeliveryFees(
    companyId: number,
    type?: string,
  ): Promise<ListDeliveryFeesResponse> {
    try {
      const response = await this.httpClient.get(
        `/companies/${companyId}/deliveryFees?type=${type}`,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir a taxa';
      }

      throw new APIError(errorMessage);
    }
  }

  public async createDeliveryFee(
    companyId: number,
    data: Partial<IDeliveryFee>,
  ): Promise<CommonDeliveryFeeResponse> {
    try {
      const response = await this.httpClient.post(
        `/companies/${companyId}/deliveryFees`,
        data,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir a taxa';
      }

      throw new APIError(errorMessage);
    }
  }

  public async updateDeliveryFee(
    id: number,
    companyId: number,
    data: Partial<IDeliveryFee>,
  ): Promise<CommonDeliveryFeeResponse> {
    try {
      const response = await this.httpClient.put(
        `/companies/${companyId}/deliveryFees/${id}`,
        data,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir a taxa';
      }

      throw new APIError(errorMessage);
    }
  }

  public async deleteDeliveryFee(id: number, companyId: number): Promise<void> {
    try {
      await this.httpClient.delete(
        `/companies/${companyId}/deliveryFees/${id}`,
      );
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir a taxa';
      }

      throw new APIError(errorMessage);
    }
  }

  public async deleteSuggestions(companyId: number): Promise<void> {
    try {
      await this.httpClient.delete(
        `/companies/${companyId}/deliveryFees/suggestions/delete`,
      );
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir as sugestões';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new DeliveryFeesService();
